import GroupObjectIcon from './component'

export default GroupObjectIcon
